import { CommonEnums } from '../../common.enums';

export class Conn_Usr {
  conn_Id: number;
  conn_Usr_Id: number;
  conn_Usr: string;
  usrPasswd: string;
  connUsrParamNm: string;
  usrPasswdParamNm: number;
  updateDt: Date;
  updateBy: string;

  constructor() {
    this.setDefaults();
  }

  setDefaults() {
    this.conn_Id = CommonEnums.defaults.LONG_VAL;
    this.conn_Usr_Id = CommonEnums.defaults.LONG_VAL;
    this.conn_Usr = CommonEnums.defaults.STRING_EMPTY;
    this.usrPasswd = CommonEnums.defaults.STRING_EMPTY;
    this.connUsrParamNm = CommonEnums.defaults.STRING_EMPTY;
    this.usrPasswdParamNm = CommonEnums.defaults.LONG_VAL;
    this.updateDt = new Date();
    this.updateBy = CommonEnums.defaults.STRING_EMPTY;
  }

  static parse(object: any): Conn_Usr {
    let conn_Usr: Conn_Usr = new Conn_Usr();
    conn_Usr.copyFrom(object as Conn_Usr);
    return conn_Usr;
  }

  copy(): Conn_Usr {
    let connTmp: Conn_Usr = new Conn_Usr();

    connTmp.conn_Id = this.conn_Id;
    connTmp.conn_Usr_Id = this.conn_Usr_Id;
    connTmp.conn_Usr = this.conn_Usr;
    connTmp.usrPasswd = this.usrPasswd;
    connTmp.connUsrParamNm = this.connUsrParamNm;
    connTmp.usrPasswdParamNm = this.usrPasswdParamNm;
    connTmp.updateDt = this.updateDt;
    connTmp.updateBy = this.updateBy;

    return connTmp;
  }

  copyFrom(connTmp: Conn_Usr): void {
    this.conn_Id = connTmp.conn_Id;
    this.conn_Usr_Id = connTmp.conn_Usr_Id;
    this.conn_Usr = connTmp.conn_Usr;
    this.usrPasswd = connTmp.usrPasswd;
    this.connUsrParamNm = connTmp.connUsrParamNm;
    this.usrPasswdParamNm = connTmp.usrPasswdParamNm;
    this.updateDt = connTmp.updateDt;
    this.updateBy = connTmp.updateBy;

  }

  compare(connTmp: Conn_Usr): string {
    let connString: string = this.toString(false);
    let connTmpString: string = connTmp.toString(false);

    if (connString != connTmpString) {
      return connString + ', ' + connTmpString;
    }

    return '';
  }

  toString(isNotCompare: boolean = true): string {
    let str: string = "Usr [conn_Id=" + this.conn_Id + ", conn_Usr_Id=" + this.conn_Usr_Id +
      ", conn_Usr=" + this.conn_Usr + ", usrPasswd=" + this.usrPasswd +
      ", connUsrParamNm=" + this.connUsrParamNm + ", usrPasswdParamNm=" + this.usrPasswdParamNm +
      ", updateDt=" + this.updateDt + ",updateBy=" + this.updateBy;
    if (isNotCompare) {
    }

    str += ']';

    return str;
  }
}
